import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
const asRecord = (value)=>typeof value === 'object' && value != null ? value : {};
export const readPersistedLocationState = (io)=>asRecord(asRecord(io.getHistoryState()).state);
export const toHistoryEnvelope = (locationState)=>({
        state: locationState
    });
export const persistLocationState = (io, patch)=>{
    io.replaceHistoryState(_object_spread({}, asRecord(io.getHistoryState()), toHistoryEnvelope(_object_spread({}, readPersistedLocationState(io), patch))));
};
